import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { EuiFlexGroup, EuiFlexItem, EuiSelect, EuiSuperSelect, EuiButtonIcon, EuiButton, EuiSwitch, EuiPanel, EuiToolTip } from '@elastic/eui';
import { AnioActual, MesActual, MesesValidacionesExpatriados } from '../../../../../../shared/utils/constants';
import { TablaValidacionFacturaExpatriados } from './tablaValidaciones';

const Anios = [{value: AnioActual-1, text:(AnioActual-1).toString()},{value: AnioActual, text:AnioActual.toString()}];

export const ValidacionExpatriadosDetalleScreen = (props:any) =>{

    const {data, visible, isLoading, perfilUser, handleFilter, selection, handleValidar,translate} = props;
    
    const [anio, setAnio] = useState(AnioActual);
    const [mes, setMes] = useState(MesActual.toString());
    const [dataUpdate, setDataUpdate] = useState<any[]>([]);
    const [vbTodos, setVbTodos] = useState<boolean>(false);
    const [periodoSeleccion, setPeriodoSeleccion] = useState(`${anio}-${mes}`);
    const [filterTypes, setFilterTypes] = useState({O:true,E:true});

    useEffect(()=>{setDataUpdate([...[]]);setVbTodos(false)},[anio, mes])
    useEffect(()=>{setDataUpdate([...data]);setVbTodos(false)},[data])

    useEffect(()=>{
        let nofacturados = dataUpdate.filter((f:any)=> (f.facturadoIrpf===false && f.facturadoRetHipot===false)).map((m:any)=> {return {...m,...{vb:vbTodos}}})
        let facturados = dataUpdate.filter((f)=> (f.facturadoIrpf===true || f.facturadoRetHipot===true))
        setDataUpdate([...facturados, ...nofacturados])
    },[vbTodos])

    const meses:any = useMemo(()=> MesesValidacionesExpatriados(anio),[translate,anio])
    const empresa = useMemo(()=> (visible===true && selection!==undefined) ? selection.idSociedad : '',[selection,visible])
    const permitirGuardar = useMemo(()=> {
        const _mes = parseInt(mes);
        return (anio===AnioActual && (_mes === MesActual || (_mes>1 && _mes=== MesActual-1))) || (anio===AnioActual-1 && (MesActual===1 && _mes===12))
    },[AnioActual,MesActual,anio,mes])

    const onClickFilter = useCallback(()=>{handleFilter({empresa:empresa,...{anio:anio,mes:parseInt(mes)}}); setPeriodoSeleccion(`${anio.toString()}-${mes}`)},[anio,mes,empresa])

    const onVbChange = (vbChanged:boolean, idEmpleado:number) => {
        let pos = dataUpdate.findIndex((p: any) => p.idEmpleado === idEmpleado);
        let newData = [ ...dataUpdate ];
        newData[pos].vb = vbChanged;
        setDataUpdate([...newData])
    };

    const onProrrateoChange  = (value:boolean, idEmpleado:number) => {
        let pos = dataUpdate.findIndex((p: any) => p.idEmpleado === idEmpleado);
        let newData = [ ...dataUpdate ];
        newData[pos].calcularProrrateo = value;
        setDataUpdate([...newData])
    };

    const onSave = () =>{
       const dataValidationRequest = dataUpdate.map((m:any)=>{return {idEmpleado:m.idEmpleado, empresa:m.empresa, anio:m.anio, mes:m.mes, vb:m.vb, calcularProrrateo:m.calcularProrrateo}})
       handleValidar(dataValidationRequest)
    }

    const getButtonSave =  useCallback(()=>{
        return dataUpdate.length>0 ?(
            <EuiFlexGroup alignItems='center' justifyContent='flexEnd'>
                <EuiFlexItem grow={false}><EuiButton className={`${permitirGuardar?'btnSave':''}`} disabled={!permitirGuardar}  size='m' fill onClick={()=>onSave()}>{translate('guardar-cambios')}</EuiButton></EuiFlexItem>
            </EuiFlexGroup>
        ):null
    },[dataUpdate,vbTodos,translate,permitirGuardar])

    const nEmpleadosObra = useMemo(()=> dataUpdate.filter((f:any)=> f.tipoEmpleado=='O').length ,[dataUpdate])
    const nEmpleadosEstructura = useMemo(()=> dataUpdate.filter((f:any)=> f.tipoEmpleado=='E').length ,[dataUpdate])

    const getCheckValidarTodos = useMemo(()=>{
        return dataUpdate.length>0 ?(
            <EuiFlexGroup alignItems='center' justifyContent='flexEnd'>
                <EuiFlexItem grow={false}>
                <EuiToolTip content='Se validan todos los empleados que no estén facturados aunque no se estén visulizando por los filtros.' position='left'>
                    <EuiSwitch checked={vbTodos} 
                    onChange={(e:any)=>{setVbTodos(e.target.checked)}} 
                    label={translate('validar-todos')} showLabel={true}/>
                </EuiToolTip>
                </EuiFlexItem>
                
            </EuiFlexGroup>
        ):null
    },[dataUpdate,vbTodos,translate])

    const getFilterTypeUser =()=>{
        return dataUpdate.length>0 &&(
                <EuiFlexGroup>
                    <EuiFlexItem grow={false}><EuiButton size='s'
                    className={`btn-filter-validaciones-expatriados obra${!filterTypes.E?' disabled': ''}`}
                    onClick={()=> {setFilterTypes({...filterTypes,...{O:!filterTypes.O}})}} 
                    iconType={!filterTypes.O? 'eyeClosed' : 'eye'}>
                        {<>{'Obra ( '}<span className='nEmpleadosObra'>{`${nEmpleadosObra}`}</span>{' )'}</>}
                    </EuiButton>
                    </EuiFlexItem>

                    <EuiFlexItem grow={false}><EuiButton size='s' 
                    className={`btn-filter-validaciones-expatriados estructura${!filterTypes.E?' disabled': ''}`}
                    onClick={()=> {setFilterTypes({...filterTypes,...{E:!filterTypes.E}})}} 
                    iconType={!filterTypes.E? 'eyeClosed' : 'eye'}>
                        {<>{'Estructura ( '}<span className='nEmpleadosEstructura'>{`${nEmpleadosEstructura}`}</span>{' )'}</>}
                    </EuiButton>
                    </EuiFlexItem>
                </EuiFlexGroup>
        )
    }

    const getDataView = useMemo(() =>{
        let _dataFilterObras = dataUpdate.filter((f: any) => (filterTypes.O===true && f.tipoEmpleado == 'O'));
        let _dataFilterEstructura = dataUpdate.filter((f: any) => (filterTypes.E===true && f.tipoEmpleado == 'E'));

        return [..._dataFilterObras,..._dataFilterEstructura];
    },[dataUpdate,filterTypes])

    if(!visible) return null;

    return (
            <EuiFlexGroup direction='column' style={{height: '100%'}}>
                <EuiFlexItem grow={false}>
                        <EuiPanel paddingSize='s'>
                            <EuiFlexGroup alignItems='center' justifyContent='spaceBetween' className='validaciones-detalle-header'>
                                <EuiFlexItem grow={2}>
                                    <EuiFlexGroup alignItems='center'>
                                        <EuiFlexItem grow={false}>
                                            <EuiSelect
                                            className='selector'
                                            onChange={(e:any) => {setAnio(parseInt(e.target.value))}}
                                            options={Anios}
                                            value={anio}
                                            />
                                        </EuiFlexItem>
                                        <EuiFlexItem>
                                            <EuiSuperSelect
                                            className='selector'
                                            fullWidth
                                            onChange={setMes}
                                            options={meses}
                                            valueOfSelected={mes}
                                            />
                                        </EuiFlexItem>
                                        <EuiFlexItem grow={false}>
                                            <EuiButtonIcon className='btnRefresh' iconType={'refresh'} size='m' iconSize='l' onClick={()=>onClickFilter()}></EuiButtonIcon>
                                        </EuiFlexItem>
                                    </EuiFlexGroup>
                                </EuiFlexItem>
                            
                                <EuiFlexItem grow={5}>
                                    {getButtonSave()}
                                </EuiFlexItem>

                            </EuiFlexGroup>
                        </EuiPanel>
                </EuiFlexItem>

                <EuiFlexItem style={{overflow:'hidden'}}>
                    <EuiPanel paddingSize='m' style={{height:'100%'}}>
                        <EuiFlexGroup direction='column' style={{height:'100%'}}>
                            <EuiFlexItem grow={false}>
                                <EuiFlexGroup alignItems='center'>
                                    {/* <EuiFlexItem grow={false}>
                                        <h4>{`${translate('nEmpleados')}: ${nEmpleados}`}</h4>
                                    </EuiFlexItem> */}
                                    <EuiFlexItem grow={false}>
                                        {getFilterTypeUser()}
                                    </EuiFlexItem>
                                    <EuiFlexItem>
                                        {getCheckValidarTodos}
                                    </EuiFlexItem>
                                </EuiFlexGroup>
                            </EuiFlexItem>
                            <EuiFlexItem style={{overflow:'auto'}}>
                                <TablaValidacionFacturaExpatriados data={getDataView} handleVbChange={onVbChange} handleProrrateoChange={onProrrateoChange}
                                translate={translate} peridoSeleccion={periodoSeleccion}/>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiPanel>
                </EuiFlexItem>
            </EuiFlexGroup>
    );
}